module.exports = __webpack_public_path__ + "static/media/web_2004.bf86d71a.jpg";